import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MODULARMARCHANT.MENUBAR.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MODULARMARCHANT.MENUBAR.DASHBOARD.TEXT',
        icon: 'bx bx-home-circle',
        link: '/',

    },
    // {
    //     id: 2,
    //     label: 'Machines',
    //     icon: 'bx bx-user',
    //     link: '/machines',
    // },
    // {
    //     id: 2,
    //     label: 'Checkers',
    //     icon: 'bx bx-user-check',
    //     link: '/checkers',
    // },
    // {
    //     id: 3,
    //     label: 'Merchant Categories',
    //     icon: 'dripicons-user',
    //     link: '/merchant-categories',
    // },
    // {
    //     id: 4,
    //     label: 'Merchants',
    //     icon: 'dripicons-user-group',
    //     link: '/merchants',
    // },
    // {
    //     id: 5,
    //     label: 'Transactions',
    //     icon: 'bx bx-list-ol',
    //     link: '/transaction',
    // },

    // {
    //     id: 3,
    //     label: 'Live Transaction',
    //     icon: 'bx bx-map-alt',
    //     link: '/live-transaction',
    // },
    {
        id: 4,
        label: 'MODULARMARCHANT.MENUBAR.TRANSACTION_REPORT.TEXT',
        icon: 'bx bx-file',
        link: '/transaction-report',
    },
    // {
    //     id: 5,
    //     label: 'Settings',
    //     icon: 'bx bx-cog',
    //     link: '/setting',

    //     // subItems: [
    //     //     {
    //     //         id: 13,
    //     //         label: 'Settings',
    //     //         link: '/point-settings',
    //     //         parentId: 9
    //     //     },
    //     //     {
    //     //         id: 13,
    //     //         label: 'Transactions',
    //     //         link: '/point-transactions',
    //     //         parentId: 9
    //     //     },
    //     // ]
    // },
 
];

